import { ReactElement } from 'react';
import {
  formatPoints,
  GENERIC_TASK_VERIFICATION_ERROR,
  StyledSvg
} from '@make-software/tg-mini-app-ui';
import { TaskReward } from 'make-traffic-integration-core';

import { USER_LOADED, USER_TASKS_LOADED } from '@/shared';

export {
  isIOS,
  getDevicePlatform,
  capitalizeFirstLetter,
  getPlatform,
  getIosBrowserKind,
  isStandalonePWA,
  openInExternalBrowser,
  copyToClipboard,
  getRewardValue,
  getTaskIconUrl,
  formatPoints
} from '@make-software/tg-mini-app-ui';

const HashLength = { FULL: 0, TINY: 5 };

export const formatHash = (hash: string, visibleHashLength: number) => {
  const MIN_TRUNCATE_HASH_LENGTH = HashLength.TINY * 2 + 3;

  const hashLength = hash.length;

  if (visibleHashLength === HashLength.FULL || hashLength <= MIN_TRUNCATE_HASH_LENGTH) {
    return hash;
  }

  const firstPart = hash.substring(0, visibleHashLength);
  const secondPart = hash.substring(hashLength - (visibleHashLength));

  return `${firstPart}...${secondPart}`;
};

export const formatSuccessTaskToastMessage = (rewards: TaskReward[]): ReactElement => {
  const rewardsIconSrc: Record<string, string> = {
    points: window.config.assets_path + '/gold.svg',
    plays: window.config.assets_path + '/fantom-run.svg'
  }

  const rewardElements = rewards.map((reward) => {
    return (
      <span key={reward.type}>
        <StyledSvg src={rewardsIconSrc[reward.type]} size={20} fillColor="#F1BF0B" /> {formatPoints(reward.value)}
      </span>
    );
  });

  const rewardSummary = rewardElements.map((element, index) => {
    if (index === 0) {
      return element;
    } else if (index === rewardElements.length - 1) {
      return <span key={`and-${index}`}>, and {element}</span>;
    } else {
      return <span key={`comma-${index}`}>, {element}</span>;
    }
  });

  return <div>Great! You've received {rewardSummary} for this task</div>;
};

export const formatDangerTaskToastMessage = (error?: string) => {
  return <div>{error ?? GENERIC_TASK_VERIFICATION_ERROR}</div>;
};

export const toWidth = (p: number): number => {
  let width = 60;
  if (p & USER_LOADED) width += 20;
  if (p & USER_TASKS_LOADED) width += 20;
  return width;
};
